require('./polyfill')

// make lodash available for angularjs
require('lodash')

require('../scripts/vendor/vendor_bundle.js')

require('./global')

require('./ng-old/shared/module-setters.js')
require('./ng-old/org/module-setters.js')
require('./ng-old/admin/module-setters.js')

require('./ng/components/legacy-angular/app-module')
require('./ng-old/org/templates.js')
require('./ng-old/shared/templates.js')
require('./ng-old/admin/templates.js')

require('./ng-old/shared/components.js')
require('./ng-old/org/components.js')

require('./ng/components/ui-application-controller')
require('./ng/components/dashboard')
require('./ng/components/syslog')
require('./ng/components/preferences')
require('./ng/components/attack-monitor')
require('./ng/components/attack-status')
require('./ng/components/promise-service')
require('./ng/components/superadmin-general-settings')
require('./ng/components/discussion')
require('./ng/components/loading')
require('./ng/components/vulnerability-trend-chart')
require('./ng/components/service-utils')
require('./ng/components/jenkins-controller')
require('./ng/components/jenkins-service')
require('./ng/components/api-keys')
require('./ng/components/application-overview')
require('./ng/components/api-keys-org')

require('./org')

export {}
